import React from 'react'
import { Container, Header, Button, Icon } from 'semantic-ui-react'
import Fade from 'react-reveal/Fade';
import '../styles/venueSection.scss';
import greenvilleImage from '../images/greenville-sc.jpg';

const venueStyles = {
  background: `linear-gradient(to right, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),
                 url('${greenvilleImage}')`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',

};

const VenueSection = props => (
  <section id="travel" className="content-deck venue" style={venueStyles}>

    <Container className="venue__container">
      <div className="venue__content">
      <Fade left>
        <div className="venue__left">
          <h1 className="venue__headline"> Venue </h1>
          <p className="venue__underline">____</p>
          <p className="venue__text">
            PME-NA<sup>40</sup> 2018 will be held at the Hyatt Regency Greenville, located in the heart of downtown.
          </p>

            <p className="venue__text">Want to make the most of your visit to Greenville, SC? &nbsp; Check out <a className="venue__link" href="https://www.visitgreenvillesc.com/" target="_blank">#yeahthatgreenville</a> online and request a free visitor's guide.</p>
        </div>
      </Fade>
      <Fade right>
        <div className="venue__location">
          <p>
            <Icon name="map" />
          </p>
          <p>
            Hyatt Regency Greenville <br />
            220 North Main Street <br />
            Greenville, South Carolina, USA, 29601 <br />
          </p>
          <Button target="_blank" href="https://book.passkey.com/gt/lodging/215184414?gtid=99f2bf3a665c3fcb8127c7a46a9a2d0e" inverted color="teal">
            More Information
          </Button>
        </div>
      </Fade>
      </div>
    </Container>
  </section>
)

export default VenueSection



// WEBPACK FOOTER //
// ./src/sections/venueSection.js